var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaiStarLightBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20845_847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4462 3.72086L29.2351 0.397942C29.5214 -0.131345 30.2696 -0.131345 30.5529 0.397942L32.3418 3.72086L35.6087 5.54048C36.129 5.83175 36.129 6.5928 35.6087 6.88093L32.3418 8.70055L30.5529 12.0235C30.2666 12.5528 29.5184 12.5528 29.2351 12.0235L27.4462 8.70055L24.1793 6.88093C23.659 6.58966 23.659 5.82862 24.1793 5.54048L27.4462 3.72086Z",
    fill: "#59B1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6566 14.0372L14.3768 5.26481C15.128 3.86486 17.1048 3.86486 17.8561 5.26481L22.5762 14.0372L31.2006 18.8384C32.5769 19.6025 32.5769 21.6132 31.2006 22.3774L22.5762 27.1786L17.8561 35.9509C17.1048 37.3509 15.128 37.3509 14.3768 35.9509L9.6566 27.1786L1.03224 22.3774C-0.344081 21.6132 -0.344081 19.6025 1.03224 18.8384L9.6566 14.0372Z",
    fill: "#59B1E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20845_847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaiStarLightBlue);
export default __webpack_public_path__ + "static/media/dai-star-light-blue.5def37b0925f2015a03d62728e2c75b2.svg";
export { ForwardRef as ReactComponent };